<script setup lang="ts">
import { type Component } from "vue";
import { storeToRefs } from "pinia";
import { useRoute, useRouter } from "vue-router";
import { List, LayoutGrid } from "lucide-vue-next";
import { Tooltip } from "@/components/ui/tooltip";
import { useResultsV2Store } from "@stores/survey/resultsV2/resultsV2";

const route = useRoute();
const router = useRouter();
const { viewLayout } = storeToRefs(useResultsV2Store());

// ?layout is the single source of truth for the viewer-side layout override: writing
// it is all this takes, and its absence means "use the view's saved default".
function setLayout(layout: string) {
  router.replace({ query: { ...route.query, layout } });
}

const LAYOUTS: Array<{ value: string; label: string; icon: Component }> = [
  { value: "list", label: "List view", icon: List },
  { value: "grid", label: "Grid view", icon: LayoutGrid },
];
</script>

<template>
  <div class="flex h-full items-center justify-end">
    <div class="flex items-center rounded-md border p-0.5">
      <Tooltip v-for="layout in LAYOUTS" :key="layout.value" :content="layout.label" :delay-duration="500">
        <button
          :aria-label="layout.label"
          class="inline-flex items-center justify-center rounded-sm px-2 py-1 transition-colors"
          :class="
            viewLayout === layout.value
              ? 'bg-muted text-foreground'
              : 'text-muted-foreground hover:text-foreground'
          "
          @click="setLayout(layout.value)">
          <component :is="layout.icon" class="h-4 w-4" />
        </button>
      </Tooltip>
    </div>
  </div>
</template>
